import styled from '@emotion/styled';

import { useTheme } from '@mui/material';
const Chip = styled.div`
  background-color: ${props => props.$bgcolor ? props.$bgcolor : "auto"};
  color: ${props => props.$color ? props.$color : "auto"};
  border-radius: 3px;
  padding: .4rem 1rem;
  font-weight: 500;
  width: fit-content;
`

const BooleanChip = ({check, values = ["Active", "Inactive"]}) => {
  const [active, inactive] = values;
  const theme = useTheme();
  let bgColor, color, statusText;
  if (check) {
    bgColor = theme.palette.success.light;
    color = theme.palette.success.main;
    statusText = active;
  } else {
    bgColor = theme.palette.error.light;
    color = theme.palette.error.main;
    statusText = inactive;
  }

  return <Chip $bgcolor={bgColor} $color={color}>{statusText}</Chip>
};

export default BooleanChip